export const countPercent = (total: number, value?: number): string => {
  if (!value) return '0%';
  const percent = ((value / total) * 100).toFixed(0);
  return percent !== '0' ? `${percent}%` : '<1%';
};

export const formatDeviceName = (device?: string): string => {
  if (!device) return '';
  return device
    .split('_')
    .map((word) => (word === 'TV' ? 'TV' : word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()))
    .join(' ');
};
